import { UserService } from './../../services/userService/user.service';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Input,
  ChangeDetectorRef,
  Renderer2
} from '@angular/core';
import {
  Router, NavigationEnd
} from '@angular/router';
import {
  RoutingService
} from '../../services/routingService/routing.service';
import {
  StorageService
} from '../../services/storage.service';
import {
  NgbDropdownConfig, NgbModal, NgbModalRef
} from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
// import { CandidateService } from 'src/app/services/candidate/candidate.service';
import { configUrl } from 'src/config';
import { ToastrService } from 'ngx-toastr';
import * as download from 'downloadjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { HomePageFeedsService } from '../../services/homePageFeed/home-page-feeds.service';
import { ApiService } from '../../shared/ApiService/api.service';
import { CandidateService } from '../../services/candidate/candidate.service';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('collapse', [
      state('open', style({
        opacity: '1',
        display: 'block',
        transform: 'translate3d(0, 0, 0)'
      })),
      state('closed', style({
        opacity: '0',
        display: 'none',
        transform: 'translate3d(100%,0, 0)'
      })),
      transition('closed => open', animate('200ms ease-in')),
      transition('open => closed', animate('100ms ease-out'))
    ])
  ],
  providers: [NgbDropdownConfig]
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  name: any;
  registerNumber: any;
  token: any;
  fileDataProfImg;
  candidateIs: Boolean = false;
  profileUpdateInfo: Boolean;
  showButton: Boolean = false;
  checkforRxpiredTokenVar: any;
  decode;
  subscription: any;
  showOption;
  userRole: any;
  showProfile;
  hideElement;
  show: Boolean = false;
  collapse: String = 'closed';
  casting: any;
  @ViewChild('loginpopup') private loginpopup: ElementRef;
  popUpContent: any;
  popUpTitle: any;
  advisModalRef: NgbModalRef;
  scheduleStartDate: any;
  scheduleEndDate: any;
  schedulePath: string;
  constructor(
    private router: RoutingService,
    config: NgbDropdownConfig,
    private route: Router,
    private storageService: StorageService,
    private userService: UserService,
    private candidate: CandidateService,
    private ref: ChangeDetectorRef,
    private candidateService: CandidateService,
    public toaster: ToastrService,
    private renderer: Renderer2,
    private modalService: NgbModal,
    private homeFeed: HomePageFeedsService,
    private advisoryModal: NgbModal,
    private apiService: ApiService
  ) {
    this.route.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url !== '/') {
          this.hideElement = true;
        } else {
          this.hideElement = false;
        }
      }
    });
    config.placement = 'bottom-right';
    config.autoClose = false;
    this.geCandidateDetails();
    this.subscription = this.candidateService.getProfileUpdateEmitter()
      .subscribe(item => this.getProfileImage());
  }

  ngOnInit() {
    this.decode = this.router.decodeToken();
    this.getLoggedInUser().then(res => {
      this.getProfileImage();
    });
    this.route.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.ref.markForCheck();
      }
    });
    this.userService.runOnUserLoginChange(this.onLoginStateChange.bind(this));
    this.getAnnouncements();
  }
  downloadFile(url){
    download(url);  
  }
  downloadpdf(url){
    this.downloadFile(url)
  }
  getPublishedSchedule() {
    this.candidateService.getGrivanceActiveSchedule().subscribe(res => {
      if (res && res.data && res.data[0] && res.data[0].status === "completed" && res.data[0].gr_status === "published") {
        // let obj = {
        //   id:1234567,
        //   slug: "schedule-grivance-publish",
        //   status: "publish",
        //   type: "casting",
        //   custom_date:res.data[0].start_date,
        //   landing_page_url:res.data[0].schedule_path,
        //   link: "https://blog.apprenticeshipindia.gov.in/casting/inviting-public-comments-on-amendments-in-apprentices-act/",
        //   title: {
        //     rendered: "Schedule for AITT 111 Grievance Redressal"
        //   },
        //   content: {
        //     rendered: "<p>Schedule for AITT 111 Grievance Redressal</p>",
        //     protected: false
        //   },
        //   protected: false,
        //   template: "",
        //   popup: 'false',
        // }
        // this.casting.splice(0, 0, obj);
      }
    }, err => {
      console.log(err);
    })
    
    this.candidateService.getActiveSchedule().subscribe(res => {
      if (res && res.data && res.data[0]) {
        this.scheduleStartDate = res.data[0].start_date;
        this.scheduleEndDate = res.data[0].end_date;
        this.schedulePath = res.data[0].schedule_path;
        // let obj = {
        //   id:123456,
        //   slug: "schedule-publish",
        //   status: "publish",
        //   type: "casting",
        //   link: "https://blog.apprenticeshipindia.gov.in/casting/inviting-public-comments-on-amendments-in-apprentices-act/",
        //   title: {
        //     rendered: "Schedule for 111 ATS AITT"
        //   },
        //   content: {
        //     rendered: "<p>Schedule for 111 ATS AITT</p>",
        //     protected: false
        //   },
        //   protected: false,
        //   template: "",
        //   popup: 'false',
        // }
        // this.casting.splice(0, 0, obj);
      }
    }, err => {
      console.log(err);
    })

  }

  getSchedule() {
    window.open(this.schedulePath, '_blank');

    // this.candidateService.downloadActiveSchedule().subscribe(res => {
    //   console.log(res);
    //   window.open(res.data[0].schedule_path, '_blank');
    // }, err => {
    //   console.log(err)
    // })
  }

  toggleCollapse() {
    // this.show = !this.show;
    this.collapse = this.collapse == 'open' ? 'closed' : 'open';
    if (this.collapse == 'open') {
      this.renderer.addClass(document.body, 'disable-scroll');
    } else {
      this.renderer.removeClass(document.body, 'disable-scroll');
    }
  }


  geCandidateDetails() {
    this.candidateService.getProfile().subscribe(res => {
      if (this.storageService.getData('access_token')) {
        this.token = this.router.decodeToken();
        if (this.token.role === 'candidate') {
          if (res) {
            this.showButton = false;
          } else {
            this.showButton = true;
          }
        } else {
          this.showButton = false;
        }
      } else {
        this.showButton = false;
      }
    });
  }

  onLoginStateChange() {
    this.decode = this.router.decodeToken();
    this.getLoggedInUser().then(prm => {
      this.getProfileImage();
    });
    this.route.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.ref.markForCheck();
      }
    });
  }

  goToProfile() {
    this.router.nextStep();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  goTocandidateProfile() {
    if (this.storageService.getData('access_token')) {
      if (this.userRole === 'candidate') {
        this.route.navigate(['candidate/profile']);
      }
    }
  }

  changepassword() {
    this.route.navigate(['candidate/change-password']);
  }

  logOut() {
    this.userService.logOut().subscribe(() => {
      this.storageService.removeData('access_token');
      this.route.navigate(['/']);
      this.decode = null;
      this.showButton = false;
      this.ref.markForCheck();
      this.userService.onUserLoginStateChange();
      window.history.forward();
    });
  }

  gotoCompleteProfile() {
    this.route.navigate(['candidate/profile']);
  }

  private handleClick(event) {
    if (this.showOption) {
      const clickedComponent = event.target;
      if (clickedComponent !== this.loginpopup.nativeElement) {
        this.showOption = false;
      }
    }
  }

  // private toggleOption() {
  //   this.showOption = this.showOption === true ? false : true;
  // }

  getLoggedInUser() {
    return new Promise((resolve, reject) => {
      if (this.storageService.getData('access_token')) {
        this.userService.getLoggedInuserDetailsForHeader().subscribe(res => {
          this.name = res.name;
          this.userRole = res.role;
          if (res.role === 'candidate') {
            this.registerNumber = res['candidate']['code'] || '';
            this.candidateIs = true;
            const buttonDestiny = res['candidate']['is_activated'];
            if (buttonDestiny === false) {
              this.showButton = true;
            } else {
              this.showButton = false;
            }
          }
          return resolve(true);
        });
      }
    })
  }

  getProfileImage() {

    if (this.storageService.getData('access_token')) {
      // this.userService.getLoggedInuserDetailsForHeader().subscribe(res => {
      //   this.name = res.name;
      // }, err => {
      //   console.log(err);
      // });
      this.candidate.candidateFilesGet(this.decode.sub, 'candidate', 'profile_image').subscribe(res => {
        this.fileDataProfImg = res['data']['filePath'];
        if (this.fileDataProfImg === '#') {
          this.fileDataProfImg = '';

        } else {

        }
      }, err => {
        console.log(err);
      });
    }
  }
  goTofeebasedLogin(id) {
    if (id === '1') {
      window.location.href = environment.btp_module;
    } else {
      window.location.href = environment.btp_module + '/direct-registration';
    }
  }

  melaRegistrationPage(){
    this.route.navigateByUrl('/mela-registration');
  }
  melaPage(){
    this.route.navigateByUrl('/pmnam-map');
  }

  ngAfterViewInit() {
    this.checkForExpiredToken();
  }

  checkForExpiredToken() {
    this.checkforRxpiredTokenVar = this.router.checkForExpiredToken();
    if (this.checkforRxpiredTokenVar === true) {
      setTimeout(() => {
        this.userService.logOut().subscribe(() => {
          this.toaster.error('Your session is expired');
          this.storageService.removeData('access_token');
          this.route.navigate(['/']);
          this.decode = null;
          this.showButton = false;
          this.ref.markForCheck();
        });
      }, 0);
    } else {
      return false;
    }
  }
  openVerticallyCentered(content?: any) {
    this.modalService.open(content, {
      centered: true,
      size: 'lg'
    });
  }
  openSbiPopUp(sbi?: any) {
    this.modalService.open(sbi, {
      centered: true,
      size: 'lg'
    });
  }
  getAnnouncements(): void {
    this.homeFeed.getCasting().subscribe(res => {
      this.casting = res;
      // this.getPublishedSchedule();
      // if (this.casting.length > 0) {
      //   this.showCasting = true;

      //   setTimeout(() => {
      //     this.renderer.setStyle(this.recentNotice.nativeElement, 'visibility', 'hidden');
      //     this.getSlickCasting();
      //     this.loadAltCast = false;
      //   }, 250);
      // }
    }, err => {
      console.log(err, 'ERRRR');
    });
  }

  openPopUp(content: any, castData: any, i: any): void {
    if (castData.id === 123456) {
      this.getSchedule();
      return;
    }
    this.casting.filter((temp) => {      
      if (castData.id === temp.id) {
        this.popUpContent = castData['popup_content'];
        this.popUpTitle = castData['popup_title'];
        this.advisModalRef = this.advisoryModal.open(content, {
          windowClass: 'modal-holder',
          centered: true,
          size: 'lg',
          backdrop: 'static',
          keyboard: false
        });
        this.advisModalRef.result.then(res => {
          if (res === 'Close click') {
            this.advisModalRef.close();
            this.advisModalRef = null;
            // this.getSlickCasting();
          }
        }, err => {
          if (err === 'Cross click') {
            this.advisModalRef.close();
            this.advisModalRef = null;
          }
        });
      }
    });
  }

  openReportPopUp(report: any): void {   
    this.modalService.open(report, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    }).result.then(result => {
      if (result === 'Close click') {        
      }
    }, err => {
      if (err === 'Cross click') {
      }
    });       
  }
}

